import { IApplicationState } from '../../types/redux';
import { getDeveloper } from './getDeveloper';

export function getDeveloperId(state: IApplicationState) {
  const developer = getDeveloper(state);

  return developer.id;
}
